import { render, staticRenderFns } from "./CashCallFormBdxList.vue?vue&type=template&id=1f0d18a0&scoped=true"
import script from "./CashCallFormBdxList.vue?vue&type=script&lang=js"
export * from "./CashCallFormBdxList.vue?vue&type=script&lang=js"
import style0 from "./CashCallFormBdxList.vue?vue&type=style&index=0&id=1f0d18a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0d18a0",
  null
  
)

export default component.exports